import { baseUrl } from "../utilities/configurations";
import { useNavigate } from "react-router-dom";
import apiRequest from "../utilities/request";
import PropTypes from "prop-types";
import React, {
  createContext,
  useCallback,
  useContext,
  useState,
  useMemo,
} from "react";

const TrackerContext = createContext();

export function useTrackerContext() {
  return useContext(TrackerContext);
}

export function TrackerProvider(props) {
  const navigate = useNavigate();

  const [upcomingAppointments, setUpcomingAppointments] = useState([]);
  const [appointmentLoadState, setAppointmentLoadState] = useState("");
  const [medicalTestLoadState, setMedicalTestLoadState] = useState("");
  const [medicalTestResults, setMedicalTestResults] = useState([]);

  const getUpcomingAppointments = async (state) => {
    try {
      setAppointmentLoadState(state || "load");
      const res = await apiRequest(
        baseUrl + `/transaction/upcoming-appointments`,
        "GET"
      );
      if (!res.error) {
        setUpcomingAppointments(res.data || []);
        setAppointmentLoadState("load success");
      } else if (res.status >= 500) {
        setAppointmentLoadState("ISE");
      } else {
        setAppointmentLoadState("load failed");
      }
    } catch (error) {
      setAppointmentLoadState("timeout");
    }
  };

  const getMedicalTestResults = async (state) => {
    try {
      setMedicalTestLoadState(state || "load");
      const res = await apiRequest(baseUrl + "/transaction/medical-tests", "GET");
      if (!res.error) {
        setMedicalTestResults(res.data || []);
        setMedicalTestLoadState("load success");
      } else if (res.status >= 500) {
        setMedicalTestLoadState("ISE");
      } else {
        setMedicalTestLoadState("load failed");
      }
    } catch (error) {
      setMedicalTestLoadState("timeout");
    }
  };

  const handleCloseTracker = useCallback(() => {
    setUpcomingAppointments([]);
    setMedicalTestResults([]);
    navigate("/home", { replace: true });
  }, [navigate]);

  const data = useMemo(
    () => ({
      setUpcomingAppointments,
      getUpcomingAppointments,
      getMedicalTestResults,
      handleCloseTracker,

      upcomingAppointments,
      appointmentLoadState,
      medicalTestLoadState,
      medicalTestResults,
    }),
    [
      upcomingAppointments,
      appointmentLoadState,
      medicalTestLoadState,
      medicalTestResults,
    ]
  );

  return (
    <TrackerContext.Provider value={data}>
      {props.children}
    </TrackerContext.Provider>
  );
}

TrackerProvider.propTypes = {
  children: PropTypes.any,
};
